<template>
  <div>
    <el-dialog title="详情"
               :visible.sync="detailsVisible"
               @close="closeModel">
      <div class="dialog-main"
           v-loading='loading'
           element-loading-text="正在加载数据中">
        <h3>订单信息</h3>
        <ul>
          <li>
            <span class="first">订单ID </span> <span>{{ detailsList.orders_sn | isNull}}</span>
          </li>
          <li>
            <span class="first">用户手机 </span> <span>{{ detailsList.buyers_mobile | isNull}}</span>
          </li>
          <li>
            <span class="first">商品名称 </span>
            <span>{{ orderlist.goods_names }}</span>
          </li>
          <li>
            <span class="first">数量 </span> <span>{{ orderlist.goods_number | isNull}}</span>
          </li>
          <li>
            <span class="first">销售价 </span>
            <span>{{ orderlist.goods_payments_amounts | isNull}}</span>
          </li>
          <li>
            <span class="first">总价 </span>
            <span>{{ orderlist.goods_payments_totals_amounts | isNull}}</span>
          </li>
          <li>
            <span class="first">优惠券 </span>
            <span>{{ detailsList.coupons_discounts_amounts | isNull}}</span>
          </li>
          <li>
            <span class="first">快递费 </span>
            <span>{{ detailsList.posts_fees | isNull}}</span>
          </li>
          <li>
            <span class="first">支付金额 </span>
            <span>{{ detailsList.payments_amounts | isNull}}</span>
          </li>
          <li>
            <span class="first">订单状态 </span>
            <span v-if="detailsList.orders_status==1">已下单</span>
            <span v-if="detailsList.orders_status==2">待发货</span>
            <span v-if="detailsList.orders_status==3">已发货</span>
            <span v-if="detailsList.orders_status==4">已完成</span>
            <span v-if="detailsList.orders_status==5">已取消</span>
          </li>
        </ul>

        <h3 v-if="!JSON.stringify(detailsList) == '{}'">支付信息</h3>
        <ul v-if="!JSON.stringify(detailsList) == '{}'">
          <li v-if="detailsList.trades_status == 1">
            <span class="first">支付状态 </span> <span>未支付</span>
          </li>
          <li v-if="detailsList.trades_status == 2">
            <span class="first">支付状态 </span> <span>付款中</span>
          </li>
          <li v-if="detailsList.trades_status == 3">
            <span class="first">支付状态 </span> <span>已支付</span>
          </li>
          <li v-if="detailsList.trades_status == 4">
            <span class="first">支付状态 </span> <span>支付失败</span>
          </li>
          <li v-if="detailsList.payments_codes == 'AliPay'">
            <span class="first">支付方式 </span> <span>支付宝</span>
          </li>
          <li v-if="detailsList.payments_codes == 'WeChatPay'">
            <span class="first">支付方式 </span> <span>微 信</span>
          </li>
          <li>
            <span class="first">支付时间 </span> <span>{{ detailsList.payments_times | isNull}}</span>
          </li>
        </ul>
        <h3>物流信息</h3>
        <ul>
          <li>
            <span class="first">发货时间 </span><span>{{ detailsList.consignments_times | isNull}}</span>
          </li>
          <li><span class="first">发货公司 </span> <span>{{bussinlist.express_company | isNull}}</span></li>
          <li>
            <span class="first">发货单号 </span> <span>{{bussinlist.express_no | isNull}}</span>
          </li>
          <li>
            <span class="first">收货人 </span> <span>{{ bussinlist.receivers_names | isNull}}</span>
          </li>
          <li>
            <span class="first">联系电话 </span>
            <span>{{ bussinlist.receivers_mobiles | isNull}}</span>
          </li>
          <li>
            <span class="first">收货地址 </span>
            <span>{{ bussinlist.receivers_provinces
             }}{{ bussinlist.receivers_citys
              }}{{ bussinlist.receivers_districts
              }}{{ bussinlist.receivers_address }}</span>
          </li>
        </ul>
        <h3 v-if="!JSON.stringify(merchant) == '{}'">商家信息</h3>
        <ul v-if="!JSON.stringify(merchant) == '{}'">
          <li>
            <span class="first">公司名称 </span> <span>{{ merchant.company_name | isNull}}</span>
          </li>
          <li>
            <span class="first">运营联系人 </span> <span>{{ merchant.operator_name | isNull}}</span>
          </li>
          <li>
            <span class="first">运营人电话 </span>
            <span>{{ merchant.operator_cellphone | isNull}}</span>
          </li>
        </ul>
        <h4 v-if="!JSON.stringify(order_refund) == '{}'">退货退款</h4>
        <ul v-if="!JSON.stringify(order_refund) == '{}'">
          <li>
            <span class="first">联系人电话 </span> <span>
              {{ order_refund.phone }}
            </span>
          </li>
          <li>
            <span class="first">申请时间 </span> <span>
              {{ order_refund.update_time }}
            </span>
          </li>
          <li>
            <span class="first">物流公司 </span> <span>
              {{ order_refund.express_company }}
            </span>
          </li>
          <li>
            <span class="first">物流单号 </span> <span>
              {{ order_refund.express_no }}
            </span>
          </li>
          <li>
            <span class="first">退货说明 </span> <span>
              {{ order_refund.reason | isNull}}
            </span>
          </li>
          <li>
            <span class="first">退款金额 </span> <span>
              <!-- {{ order_refund.amount }} -->
            </span>
          </li>
          <li class="imgsli"
              v-if="image.length>0">
            <span class="first">上传凭证 </span> <span>
              <el-image style="width: 100px; height: 100px"
                        v-if="(item,index) in image"
                        :key="index"
                        :preview-src-list="srcList"
                        :z-index="9999"
                        :src="item"></el-image>
            </span>
          </li>
        </ul>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="closeModel">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { orderListDetail } from "@/api/orderManage/index";
export default {
  props: {
    details_id: {
      require: true
    }
  },
  data () {
    return {
      detailsVisible: true,
      loading: false,
      detailsList: {},
      orderlist: {},
      bussinlist: {},
      merchant: {},
      order_refund: {},
      image: []
    };
  },
  methods: {
    closeModel () {
      this.$emit("closeModel");
    },
    initorderListDetail () {
      this.loading = true
      const date = {
        token: this.$getSessionStorage('token'),
        id: this.details_id,
      };
      orderListDetail(date).then(res => {
        if (res.code == 1) {
          this.loading = false
          this.detailsList = res.data;
          this.orderlist = res.data.orders_goods;
          if (res.data.orders_deliveries) {
            this.bussinlist = res.data.orders_deliveries;
          }
          this.merchant = res.data.merchant_users_mains;
          if (res.data.order_refund) {
            this.order_refund = res.data.order_refund;
            if (res.data.order_refund.image) {
              let arr = res.data.order_refund.image.split(',')
              this.image = arr
            }
          }
        } else {
          this.$message.error(res.msg)
        }
      })

    }

  },
  mounted () {
    if (this.details_id) {
       this.initorderListDetail()
    }
   
  },
  components: {

  },
};
</script>

<style scoped lang="scss">
.dialog-main {
  width: 100%;
  ul {
    width: 100%;
    overflow: hidden;
    padding: 10px 0px;
    margin-bottom: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.09);
    li {
      width: 50%;
      float: left;
      padding: 10px 0;
      color: #000;
      .first {
        width: 100px;
        color: #666666;
        display: inline-block;
        padding-left: 10px;
      }
    }
    .imgsli {
      display: flex;
      align-items: center;
    }
  }
}
</style>
